module.exports = __webpack_public_path__ + "img/www.edmunds.com.b8628266.png";